import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((n) => !n.read).length;
  const toggle = async (o) => {
    setOpen(o);
    if (!o && unread) {
      await api.post("/notifications/read-all");
      load();
    }
  };

  return (
    <Popover open={open} onOpenChange={toggle}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative w-8 h-8 rounded-lg hover:bg-slate-100 flex items-center justify-center">
          <Bell className="w-4 h-4 text-slate-600" />
          {unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 max-w-[calc(100vw-1rem)] p-0">
        <div className="px-4 py-3 border-b font-semibold text-sm">Bildirimler</div>
        <div className="max-h-96 overflow-y-auto" data-testid="notification-list">
          {items.length === 0 && <div className="p-6 text-center text-sm text-slate-500">Bildirim yok</div>}
          {items.map((n) => (
            <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => { toggle(false); navigate(n.link); }}
              className={`w-full text-left px-4 py-3 border-b last:border-0 hover:bg-slate-50 ${n.read ? "" : "bg-emerald-50/60"}`}>
              <div className="text-sm font-medium text-slate-900">{n.title}</div>
              <div className="text-xs text-slate-600 mt-0.5">{n.message}</div>
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("tr-TR")}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
